import React, { useEffect, useState } from "react";
import useSEO from "../hooks/useSEO";
import { Breadcrumb, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";

export default function VideoGallery() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 SEO
  const [seo, setSeo] = useState({
    title: "Video Gallery | Kashi Journeys",
    description: "",
    keywords: "",
  });

  useSEO({
    title: seo.title,
    description: seo.description,
    keywords: seo.keywords,
    canonical: window.location.href,
    ogImage: "",
  });

  // 🔹 Fetch Video Gallery
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.VIDEO_GALL,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        console.log("Video Gallery API:", res.data);

        if (res.data?.status) {
          setVideos(res.data.videos || []);
          setSeo({
            title: res.data.page?.title || "Video Gallery",
            description: res.data.page?.description || "",
            keywords: res.data.page?.keywords || "",
          });
        }
      } catch (err) {
        console.error("Video Gallery API Error:", err);
        setVideos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (loading) {
    return <p className="text-center py-5">Loading videos...</p>;
  }

  return (
    <div>
      {/* 🔹 Breadcrumb */}
      <div className="BreadcrumbStyle">
        <Container>
          <h1>Video Gallery</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Video Gallery</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      {/* 🔹 Video Grid */}
      <div className="pageStyle">
        <Container>
          <Row className="g-4">
            {videos.length > 0 ? (
              videos.map((item) => (
                <Col md={4} sm={6} xs={12} key={item.id}>
                  <div className="video-card h-100">
                    <div
                      className="ratio ratio-16x9 rounded overflow-hidden"
                      dangerouslySetInnerHTML={{
                        __html: item.videoiframe,
                      }}
                    />
                    <h6 className="mt-2 text-center">
                      {item.title}
                    </h6>
                  </div>
                </Col>
              ))
            ) : (
              <p className="text-center">No videos found</p>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
}
